import React, { FC } from "react"
import Image from "next/image"

type Props = {
  icon: string
  icon2: string
  icon3: string
  title: string
  heading: string
  sub_heading: string
  para1: string
  para2: string
  para3: string
  para4: string
}

export const BenchmarksCard: FC<Props> = ({
  icon,
  title,
  heading,
  sub_heading,
  icon2,
  icon3,
  para1,
  para2,
  para3,
  para4,
}) => {
  return (
    <div className="dark:bg-primary-1 bg-white border-2 dark:border-secondary-11 rounded-xl mt-4 px-5 py-6 h-full">
      <div className="flex gap-x-4 border-b-2 dark:border-secondary-12">
        <div className="dark:bg-secondary-13 rounded-full p-2 h-10">
          <Image
            className="w-6 text-primary-13"
            src={icon}
            width={100}
            height={100}
            alt="icon"
          />
        </div>
        <div>
          <h1 className="dark:text-primary-10 text-light-2 2xl:text-22 text-lg">
            {title}
          </h1>
          <p className="py-2 text-sm dark:text-primary-14 text-gray-500">
            {heading}
          </p>
          <p className="text-xs dark:text-primary-8 text-light-1">
            {sub_heading}
          </p>
        </div>
      </div>
      <div className="flex gap-x-4 border-b-2 dark:border-secondary-12 py-8">
        <div className="dark:bg-secondary-13 rounded-full p-2 h-10">
          <Image
            className="w-6"
            src={icon2}
            width={100}
            height={100}
            alt="icon"
          />
        </div>
        <div className="dark:text-primary-14 text-gray-500">
          <p>{para1}</p>
          <p>{para2}</p>
        </div>
      </div>
      <div className="flex gap-x-4 pt-9">
        <div className="dark:bg-secondary-13 rounded-full p-2 h-10">
          <Image
            className="w-6"
            src={icon3}
            width={100}
            height={100}
            alt="icon"
          />
        </div>
        <div className="dark:text-primary-14 text-gray-500">
          <p>{para3}</p>
          <p>{para4}</p>
        </div>
      </div>
    </div>
  )
}
